import axios from "axios";
import { checkForAuthorization } from "utilities/index";

// Founder app usage, behind the admin "Active Users" and "Average Session
// Time" analytics. Served by startup-backend's /app-sessions routes.
const appSessionUrl = (path) =>
    `${process.env.REACT_APP_BASE_URL}/app-sessions/${path}`;

// Tracking is invisible plumbing - a failure here must never reach the founder,
// so every call swallows its own errors.
const post = async (path, payload) => {
    try {
        await axios({
            method: "post",
            url: appSessionUrl(path),
            headers: { Authorization: `Bearer ${checkForAuthorization()}` },
            data: payload,
        });
    } catch (error) {
        // Intentionally silent.
    }
};

export const startAppSession = ({ session_id, startup_id }) => {
    if (!session_id || !checkForAuthorization()) return;
    return post("start", { session_id, ...(startup_id ? { startup_id } : {}) });
};

// `keepalive` rather than navigator.sendBeacon: the endpoint needs an
// Authorization header, and sendBeacon cannot set one.
export const sendAppSessionHeartbeat = ({ session_id, active_seconds, keepalive = false }) => {
    if (!session_id || !checkForAuthorization()) return;

    const body = { session_id, active_seconds: Math.max(0, Math.floor(active_seconds)) };

    if (!keepalive) return post("heartbeat", body);

    try {
        return fetch(appSessionUrl("heartbeat"), {
            method: "POST",
            keepalive: true,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${checkForAuthorization()}`,
            },
            body: JSON.stringify(body),
        }).catch(() => { });
    } catch (error) {
        // Intentionally silent.
    }
};
